import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { Reference } from 'types/reference';
import Image from 'frontastic/lib/image';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { tablet } from 'helpers/utils/screensizes';
import { StaticImageData } from 'next/image';
import Markdown from 'components/commercetools-ui/organisms/markdown';
import usePreloadImages from 'helpers/hooks/usePreloadImages';
import Head from 'next/head';
import { Tiempos } from 'fonts';
export interface SectionWithBannerProps {
  data: any;
}
const SectionWithBanner: React.FC<SectionWithBannerProps> = ({ data }) => {
  const [isTabletSize] = useMediaQuery(tablet);
  const webpUrl = data?.banner_image?.url.replace(/\.[^/.]+$/, ".webp");
  const avifUrl = data?.banner_image?.url.replace(/\.[^/.]+$/, ".avif");
  // usePreloadImages([data?.banner_image?.url]);
  return (
    <div className="relative w-full">
     <Head>
        <link
          rel="preload"
          href={webpUrl}
          as="image"
          imageSrcSet={`${webpUrl} 1200w,
          ${webpUrl}?w=200 200w, 
          ${webpUrl}?w=400 400w, 
          ${webpUrl}?w=800 800w, 
          ${webpUrl}?w=1024 1024w`}
        />
      </Head>
      <>
        {data?.banner_desktop_image?.url || data?.banner_image?.url ? (
          <div className="relative h-[23rem] lg:h-[32rem] 3xl:h-[40rem]">
            <Image
              // {...image}
              src={
                isTabletSize
                  ? data?.banner_desktop_image?.url || data?.banner_image?.url
                  : data?.banner_desktop_image?.url || data?.banner_image?.url
              }
              loading="eager"
              alt={data?.banner_desktop_image?.description}
              fill
              style={{ objectFit: 'cover', objectPosition: '85% 100%'}}
              className="brightness-50"
              height={500}
              width={500}
            />
          </div>
        ) : (
          <div className=""></div>
        )}
        <div
          className={`absolute left-[15%] top-1/3 max-w-[675px]  -translate-y-1/2 transform px-24  lg:px-0 ${
            data?.content_alignment === 'Center' ? 'text-center' : 'text-left'
          }`}
        >
          <Typography
            as="h1"
            className={`pt-128 text-32 font-semibold leading-[3rem] text-white drop-shadow-sm lg:mt-120 lg:w-[32rem] xl:text-36 2xl:text-48 ${Tiempos.className}`}
          >
            {data?.heading}
          </Typography>
          <Markdown
            markdown={data?.description}
            className="my-24 whitespace-pre-line text-16 font-normal leading-[2rem] text-white lg:w-[32rem] xl:text-14 2xl:text-20"
          />
          {data.ctas?.length > 0 &&
            data.ctas.map((ctaButton: any, index: number) => (
              <Link key={index} link={ctaButton?.button?.href}>
                <Button className="border-1 rounded-none border border-[#2B2C39] bg-white px-32 py-18 shadow-sm hover:!border-[#F4F4F4] hover:!bg-[#F4F4F4]">
                  <Typography as="span" className=" text-16 font-medium leading-6 text-[#090909]">
                    {ctaButton?.button?.title}
                  </Typography>
                </Button>
              </Link>
            ))}
        </div>
      </>
    </div>
  );
};
export default SectionWithBanner;